import { Resolution } from '@/api-client/models/utilization/Contracts'
import { differenceInDays } from 'date-fns'

export function resolutionFromTimespan(startDate?: string, endDate?: string): Resolution {
  if (!startDate || !endDate) return 'DAY'
  const difference = Math.abs(differenceInDays(new Date(startDate), new Date(endDate)))
  if (difference > 364) return 'YEAR'
  if (difference > 60) return 'MONTH'
  if (difference > 13) return 'WEEK'
  return 'DAY'
}
